<template>
  <div lazy-validation>
    <v-layout row>
      <v-flex xs12 sm12>
        <p style="text-align: center">
          "Es opcional añadir invitados internos a tu cita, si deseas solo
          añadir invitados externos regresa al paso anterior."
        </p>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12 sm12>
        <v-radio-group row v-model="type">
          <v-radio color="primary" label="Institucional" value="I" />
          <v-radio
            color="primary"
            :label="'Niveles (' + selected.levels.length + ')'"
            value="N"
          />
          <v-radio
            color="primary"
            :label="'Grupos (' + selected.ggs.length + ')'"
            value="G"
          />
          <v-radio
            color="primary"
            :label="'Subgrupos (' + selected.subgroupIds.length + ')'"
            value="SG"
          />
          <!--<v-radio color="primary" :label="'Colaboradores (' + selected.webRoleIds.length + ')'" value="C"/>-->
          <v-radio
            color="primary"
            :label="'Estudiantes (' + selected.students.length + ')'"
            value="E"
          />
          <v-radio
            color="primary"
            :label="'Tutores (' + selected.tutors.length + ')'"
            value="T"
          />
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout row v-if="showSearch">
      <v-flex
        xs6
        sm6
        class="titleSearch"
        justify-end
        style="margin-left: auto; margin-botom: 30px"
      >
        <v-text-field
          flat
          :label="$t('generic.search')"
          append-outer-icon="search"
          clearable
          solo-inverted
          hide-details
          @keyup="searchStudents"
          @click:append-outer="searchStudents"
          @click:clear="clearSearch"
          v-model="search"
        />
      </v-flex>
    </v-layout>
    <v-layout row v-if="showSearch">
      <v-flex
        xs6
        sm6
        class="titleSearch"
        justify-end
        style="margin-left: auto; margin-botom: 30px"
      >
        <div
          style="font-size: 12px; color: rgba(0, 0, 0, 0.54); margin-top: 10px"
        >
          Es opcional añadir invitados internos o externos, pero debes añadir
          alguno de los dos
        </div>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-slide-x-transition mode="out-in">
        <v-flex xs12 :key="3" v-if="type == 'I'">
          <v-layout justify-center align-center fill-height row wrap>
            <v-flex xs6>
              <v-alert
                style="border-radius: 33px"
                :value="true"
                type="info"
                color="gradiente"
                >Toda la institución será notificada</v-alert
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :key="0" v-if="type == 'N'">
          <lSelection
            v-if="userPermissions['WATCH_LEVELS']"
            v-model="selected.levels"
            :array="filteredArray"
          />
          <p v-else>No tienes permisos para visualizar niveles</p>
        </v-flex>
        <v-flex xs12 :key="1" v-if="type == 'G'">
          <gSelection
            v-if="userPermissions['WATCH_LEVELS']"
            v-model="selected.ggs"
            :array="filteredArray"
          />
          <p v-else>No tienes permisos para visualizar grupos</p>
        </v-flex>
        <v-flex xs12 :key="3" v-if="type == 'SG'">
          <sgSelection
            v-if="userPermissions['WATCH_SUBGROUPS']"
            v-model="selected.subgroupIds"
            :array="filteredArray"
          />
          <p v-else>No tienes permisos para visualizar subgrupos</p>
        </v-flex>
        <v-flex xs12 :key="4" v-if="type == 'E'">
          <sSelection
            v-if="userPermissions['WATCH_STUDENTS']"
            v-model="selected.students"
            :array="filteredArray"
            :showBtnScroll="showBtnScroll"
            @viewMore="viewMoreClick"
          />
          <p v-else>No tienes permisos para visualizar estudiantes</p>
        </v-flex>
        <v-flex xs12 :key="5" v-if="type == 'C'">
          <cSelection v-model="selected.webRoleIds" :array="filteredArray" />
        </v-flex>

        <v-flex xs12 :key="6" v-if="type == 'T'">
          <tSelection
            v-if="userPermissions['WATCH_PARENTS']"
            v-model="selected.tutors"
            :array="filteredArray"
            :showBtnScroll="showBtnScroll"
            @viewMore="viewMoreClickTutors"
          />
          <p v-else>No tienes permisos para visualizar tutores</p>
        </v-flex>
      </v-slide-x-transition>
    </v-layout>
  </div>
</template>

<script>
import cSelection from './ColaboratorsSelection'
import gSelection from './GGsSelection'
import lSelection from './LevelsSelection'
import sgSelection from './SGsSelection'
import sSelection from './StudentsSelection'
import tSelection from './TutorsSelection'

export default {
  components: {
    lSelection,
    gSelection,
    sSelection,
    sgSelection,
    tSelection,
    cSelection,
  },
  props: ['cancel', '_object', 'userPermissions'],
  data: () => ({
    search: '',
    type: '',
    showSearch: false,
    selected: {
      levels: [],
      ggs: [],
      students: [],
      tutors: [],
      subgroupIds: [],
      webRoleIds: [],
      institutional: false,
    },
    studentsFilter: [],
    tutorsFilter: [],
    offset: 0,
    showBtnScroll: false,
    updateStudentsArea: false,
    updateTutorsArea: false,
    showSarchTutors: true,
  }),
  watch: {
    cancel() {
      if (this.cancel) {
        this.selected = {
          levels: [],
          ggs: [],
          webRoleIds: [],
          subgroupIds: [],
          students: [],
          tutors: [],
          institutional: false,
        }
      }
    },
    _object() {
      //PARA HACER LA EDICIÓN DE AUDIENCIA SE NECESITA TRAER LOS OBJETOS LLENOS (LEVELS, GROUPS, STUDENTS) NO SOLO TENER LOS ID'S
      if (this._object !== null) {
        if (this._object.audience.institutional) {
          this.type = 'I'
        } else if (this._object.levels.length > 0) {
          this.type = 'N'
          this.selected.levels = this._object.levels
          this.selected.subgroupIds = []
          this.selected.ggs = []
          this.selected.students = []
          this.selected.webRoleIds = []
          this.selected.tutors = []
        } else if (this._object.groups.length > 0) {
          this.type = 'G'
          this.selected.levels = []
          this.selected.subgroupIds = []
          this.selected.ggs = this._object.groups
          this.selected.students = []
          this.selected.webRoleIds = []
          this.selected.tutors = []
        } else if (this._object.subgroupIds.length > 0) {
          this.type = 'SG'
          this.selected.levels = []
          this.selected.subgroupIds = this._object.subgroupIds
          this.selected.students = []
          this.selected.ggs = []
          this.selected.webRoleIds = []
          this.selected.tutors = []
        } else if (this._object.students.length > 0) {
          this.type = 'E'
          this.selected.levels = []
          this.selected.ggs = []
          this.selected.subgroupIds = []
          this.selected.webRoleIds = []
          this.selected.tutors = []
          this.selected.students = this._object.students
        } else if (this._object.webRoleIds.length > 0) {
          this.type = 'C'
          this.selected.levels = []
          this.selected.ggs = []
          this.selected.subgroupIds = []
          this.selected.students = []
          this.selected.tutors = []
          this.selected.webRoleIds = this._object.webRoleIds
        } else if (this._object.webRoleIds.length > 0) {
          this.type = 'T'
          this.selected.levels = []
          this.selected.ggs = []
          this.selected.subgroupIds = []
          this.selected.students = []
          this.selected.webRoleIds = []
          this.selected.tutors = this._object.tutors
        } else {
          this.type = 'I'
        }
      } else {
        this.type = 'I'
      }
    },
    type: {
      handler() {
        switch (this.type) {
          case 'I':
            this.selected.levels = []
            this.selected.ggs = []
            this.selected.students = []
            this.selected.tutors = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = true
            this.showSearch = false
            break
          case 'N':
            this.selected.ggs = []
            this.selected.students = []
            this.selected.tutors = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            this.showSearch = true

            break
          case 'G':
            this.selected.levels = []
            this.selected.students = []
            this.selected.tutors = []
            this.selected.subgroupIds = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            this.showSearch = true

            break
          case 'SG':
            this.selected.levels = []
            this.selected.students = []
            this.selected.tutors = []
            this.selected.ggs = []
            this.selected.webRoleIds = []
            this.selected.institutional = false
            this.showSearch = true

            break
          case 'C':
            this.selected.levels = []
            this.selected.students = []
            this.selected.tutors = []
            this.selected.ggs = []
            this.selected.subgroupIds = []
            this.selected.institutional = false
            this.showSearch = true

            break
          case 'E':
            this.selected.levels = []
            this.selected.tutors = []
            this.selected.ggs = []
            this.selected.webRoleIds = []
            this.selected.subgroupIds = []
            this.selected.institutional = false
            this.getStudentsByBranch(false)
            this.showSearch = true

            break

          case 'T':
            this.selected.levels = []
            this.selected.students = []
            this.selected.ggs = []
            this.selected.webRoleIds = []
            this.selected.subgroupIds = []
            this.selected.institutional = false
            this.getTutorsByBranch(false)
            this.showSearch = true

            //this.getTutors();
            break
        }
      },
      deep: true,
    },
    selected: {
      handler() {
        this.deleteSelectedOfSearch()
        this.search = ''
        this.$emit('selected', this.selected)
      },
      deep: true,
    },
  },
  computed: {
    filteredArray() {
      var transformMap = {
        a: '[aá]',
        e: '[eé]',
        i: '[ií]',
        o: '[oó]',
        u: '[uí]',
        A: '[AÁ]',
        E: '[EÉ]',
        I: '[IÍ]',
        O: '[OÓ]',
        U: '[UÚ]',
      }
      var search = this.search ? this.search : ''
      search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      for (var key in transformMap) {
        search = search.replace(key, transformMap[key])
      }
      var matcher = new RegExp(search, 'i')
      var array = []
      var vm = this

      switch (this.type) {
        case 'N':
          array = this.levels.filter((value) => {
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.id) {
                return false
              }
            }
            return matcher.test([value.typeLevel].join())
          })
          break
        case 'G':
          array = this.ggs.filter((value) => {
            for (var g in vm.selected.ggs) {
              if (vm.selected.ggs[g].id == value.id) {
                return false
              }
            }
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.level.id) {
                return false
              }
            }
            return matcher.test(
              [value.grade + ' ' + value.group, value.level.typeLevel].join()
            )
          })
          break
        case 'SG':
          array = Array.from(this.subgroupIds)
          break
        case 'C':
          array = Array.from(this.webRoleIds)
          break
        case 'E':
          array = this.studentsFilter
          break
        case 'T':
          array = this.tutorsFilter
          break
      }
      return array
    },
  },
  mounted() {
    this.getTools()
    this.getSubGroups()
    this.getRoles()
    this.getStudentsByBranch(true)
    this.getTutorsByBranch(true)
    //this.getTutors();
  },
  methods: {
    viewMoreClick() {
      this.offset = this.offset + 20
      this.getStudentsByBranch(true)
    },
    viewMoreClickTutors() {
      this.offset = this.offset + 20
      this.getTutorsByBranch(true)
    },
    getStudentsByBranch(isScroll) {
      if (isScroll === false) {
        this.offset = 0
      }

      var params = {
        search: this.search,
        page_size: 20,
        offset: this.offset,
      }
      this.$store
        .dispatch('student/getByBranch', params)
        .then((response) => {
          let posts = response.data
          this.updateStudentsArea = true
          if (isScroll) {
            if (posts.length) {
              this.studentsFilter = this.studentsFilter.concat(posts)
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          } else {
            this.studentsFilter = posts
            if (posts.length) {
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          }
          this.deleteSelectedOfSearch()
        })
        .catch(() => {})
    },

    getTutorsByBranch(isScroll) {
      if (isScroll === false) {
        this.offset = 0
      }

      var paramsTutors = {
        search: this.search,
        page_size: 20,
        offset: this.offset,
      }
      this.$store
        .dispatch('tutor/getTutors', paramsTutors)
        .then((response) => {
          let posts = response.data.data
          this.updateTutorssArea = true
          if (isScroll) {
            if (posts.length) {
              this.tutorsFilter = this.tutorsFilter.concat(posts)
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          } else {
            this.tutorsFilter = posts
            if (posts.length) {
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          }
          this.deleteTutorsSelectedOfSearch()
        })
        .catch(() => {})
    },

    getTutors(isScroll) {
      this.filters = {
        size: 10,
        offset: 0,
        search: '',
      }

      this.$store
        .dispatch('tutor/getTutors', this.filters)
        .then((response) => {
          let posts = response.data
          //this.updateStudentsArea = true;
          if (isScroll) {
            if (posts.length) {
              this.studentsFilter = this.studentsFilter.concat(posts)
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          } else {
            this.studentsFilter = posts
            if (posts.length) {
              this.showBtnScroll = true
            } else {
              this.showBtnScroll = false
            }
          }
          //this.deleteSelectedOfSearch();

          this.tutors = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSubGroups() {
      this.$store
        .dispatch('notice/getSubgrupos')
        .then((response) => {
          this.subgroupIds = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getRoles() {
      this.$store
        .dispatch('employee/getTools')
        .then((response) => {
          this.webRoleIds = response.data.entity.roles
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getTools() {
      this.$store
        .dispatch('notice/getNoticeTools')
        .then((response) => {
          this.levels = response.data.entity.levels
          this.ggs = response.data.entity.ggs
        })
        .catch(() => {})
    },
    searchStudents() {
      if (this.type === 'E') {
        this.offset = 0
        this.getStudentsByBranch(false)
      }

      if (this.type === 'T') {
        this.offset = 0
        this.getTutorsByBranch(false)
      }
    },
    clearSearch() {
      if (this.type === 'E') {
        this.offset = 0
        this.search = ''
        this.getStudentsByBranch(false)
      }

      if (this.type === 'T') {
        this.offset = 0
        this.search = ''
        this.getTutorsByBranch(false)
      }
    },
    deleteSelectedOfSearch() {
      for (var s in this.selected.students) {
        for (var sf in this.studentsFilter) {
          if (this.selected.students[s].id == this.studentsFilter[sf].id) {
            this.studentsFilter.splice(sf, 1)
          }
        }
      }
    },

    deleteTutorsSelectedOfSearch() {
      for (var s in this.selected.tutors) {
        for (var sf in this.tutorsFilter) {
          if (this.selected.tutors[s].id == this.tutorsFilter[sf].id) {
            this.tutorsFilter.splice(sf, 1)
          }
        }
      }
    },
  },
}
</script>

<style>
label[for*='descriptionField'],
label[htmlfor*='descriptionField'] {
  top: 0;
  line-height: 13px !important;
}
</style>
